"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollEnable = exports.Layer = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Layer = _styledComponents.default.div(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  position: fixed;\n  z-index: ", ";\n"], ["\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  position: fixed;\n  z-index: ", ";\n"])), function (props) {
  return props.zIndex;
});

exports.Layer = Layer;
Layer.defaultProps = {
  zIndex: 1001
};

var ScrollEnable = _styledComponents.default.div(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  overflow: scroll;\n  height: 100vh;\n"], ["\n  overflow: scroll;\n  height: 100vh;\n"])));

exports.ScrollEnable = ScrollEnable;
var templateObject_1, templateObject_2;